import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=78ef55aa&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=78ef55aa&lang=scss&scoped=true&"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ef55aa",
  null
  
)

export default component.exports